<template>
    <div>
        <!-- Header -->
        <header class="cover-header">
            <div class="innr">
                <h1><a href="//dr.mdsqr.com" title="Mdtalk For pharmacy"><img src="../assets/images/new/logo.png" width="210" height="44" /></a><span>for Pharmacies</span></h1>
                <div class="msg">
                    <a href="mailto:partner@mdsqr.com" title="회원가입 문의">
                        회원가입 문의
                    </a>
                </div>
            </div>
        </header>

        <div class="container_new">
            <div class="cont">
                <section id="sctn_01" class="sctn_01">
                    <div class="inner">
                        <div class="tt_area">
                            <h2>
                                비대면 진료 <strong style="font-weight: bold !important">No.1</strong> 플랫폼
                            </h2>
                            <p>
                                중소벤처기업부 창업진흥원＋Google Play<br />
                                지원사업 선정 혁신 벤처기업
                            </p>
                            <img src="../assets/images/new/sctn_01/ci.png" width="690" height="100" />
                            <div class="btn_box">
                                <a class="btn_drmd" href="#" @click.prevent="$router.push('/login')" title="병원 로그인">약국 로그인</a>
                                <a class="btn_drmd" href="#" @click.prevent="$router.push('/join/1')" title="병원 로그인">가입하기</a>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- <section id="sctn_04" class="sctn_04" data-aos="fade-up"> -->
                <section id="sctn_04" class="sctn_04">
                    <div class="inner">
                        <h2>비대면 진료 <strong style="font-weight: bold !important">진료</strong> 플랫폼 <strong style="font-weight: bold !important">MDtalk</strong><span>언택트 시대에 엠디톡이 여러분과 함께 합니다!</span></h2>
                        <div class="youtube">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/fKpmijf8mIk" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                        <div class="lst_area">
                            <div class="tit_area">
                                <h3><a href="#" title="닥큐"><img src="../assets/images/new/sctn_04/icon_doc.png" width="49" height="49" alt="" /></a></h3>
                                <div class="icn_play"><span>사소한 것까지 의사에게 물어보는 본격 '닥큐'채널</span></div>
                            </div>
                            <div class="lst">
                                <ul>
                                    <li>
                                        <a href="https://youtu.be/3QzkyxwZQ7g" target="_blank" title="불면증의 원인과 치료법! 하루 적정 수면시간 8시간 유지하는 방법 #불면증치료법 #불면증원인 #불면증 #전화처방">
                                            <div class="thmb">
                                                <img src="../assets/images/new/sctn_04/thmb_01.png" width="237" height="132" alt="" />
                                            </div>
                                            <p class="dtl">불면증의 원인과 치료법! 하루 적정 수면시간 8시간 유지하는 방법 #불면증치료법 #불면증원인 #불면증 #전화처방</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://youtu.be/DQz76-B1owE" target="_blank" title="해외에서 아플 때 앱으로 한국인 의사선생님과 상담하자! #전화상담 #비대면 #전화처방">
                                            <div class="thmb">
                                                <img src="../assets/images/new/sctn_04/thmb_02.png" width="237" height="132" alt="" />
                                            </div>
                                            <p class="dtl">해외에서 아플 때 앱으로 한국인 의사선생님과 상담하자! #전화상담 #비대면 #전화처방</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://youtu.be/qwkCcSfMBGs" target="_blank" title="[오늘의 건강] 과음 후 숙취해소법을 알려드립니다 #숙취해소 #숙취해소방법 #숙취 #전화처방">
                                            <div class="thmb">
                                                <img src="../assets/images/new/sctn_04/thmb_03.png" width="237" height="132" alt="" />
                                            </div>
                                            <p class="dtl">[오늘의 건강] 과음 후 숙취해소법을 알려드립니다 #숙취해소 #숙취해소방법 #숙취 #전화처방</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://youtu.be/Td4qIQ6oKzI" target="_blank" title="치과 의사가 알려주는 임플란트 수술 전 후 주의사항! 이보다 꼼꼼하게 알려주는 영상은 없었다! #당뇨환자 #고지혈증약 #골다공증 #전화처방">
                                            <div class="thmb">
                                                <img src="../assets/images/new/sctn_04/thmb_04.png" width="237" height="132" alt="" />
                                            </div>
                                            <p class="dtl">치과 의사가 알려주는 임플란트 수술 전 후 주의사항! 이보다 꼼꼼하게 알려주는 영상은 없었다! #당뇨환자 #고지혈증약 #골다공증 #전화처방</p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- <section id="sctn_03" class="sctn_03" data-aos="fade-up"> -->
                <section id="sctn_03" class="sctn_03">
                    <div class="inner">
                        <div class="tt_area">
                            <p class="tdun">광고/제휴/회원가입 문의<strong style="font-weight: bold !important">partner@mdsqr.com</strong></p>
                            <p>
                                연락처를 남겨주시면 <strong style="font-weight: bold !important">담당자가<br /> 친절히 안내</strong>해 드리겠습니다.
                            </p>
                            <dl>
                                <dt>안내전화</dt>
                                <dd>02 6953 3693</dd>
                            </dl>
                            <p>고객센터 cs@mdsqr.com</p>
                            <a href="mailto:partner@mdsqr.com" class="btn_drmd">회원가입 문의</a>
                        </div>
                    </div>
                </section>

            </div>
        </div>

        <!-- Footer -->
        <footer class="footer">
            <div class="inner">
                <div class="ft_ct">
                    <h1><a href="#"><img src="../assets/images/new/ft_logo.png" width="152" height="58" /></a></h1>
                    <ul class="sns">
                        <li class="nv"><a href="https://blog.naver.com/mdtalk" target="_blank"><img src="../assets/images/new/icon_blog.png" width="50" height="39" title="MDtalk Blog" /></a></li>
                        <li class="fb"><a href="https://www.facebook.com/MDtalk-엠디톡-111480020260742/" target="_blank"><img src="../assets/images/new/icon_fb.png" width="50" height="39" title="MDtalk facebook" /></a></li>
                    </ul>
                    <ul>
                        <li><a href="https://images.mdtalk.io/node/test/static/doc/terms.html" target="_blank">이용약관</a></li>
                        <li><a href="https://images.mdtalk.io/node/test/static/doc/privacy_01.html" target="_blank">개인정보취급방침</a></li>
                        <li><a href="mailto:partner@mdsqr.com">회원가입 문의</a></li>
                    </ul>
                    <address>
                        (주)엠디스퀘어 | 서울특별시 강남구 강남대로 146길 17, 2층 | COPYRIGHT(C) 2019. MDSQUARE ALL RIGHTS RESERVED
                    </address>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import { nameByConstMixin } from '@/lib/mixins'

    // import TermsPrivacy from '../components/Join/TermsPrivacy'
    // import TermsService from '../components/Join/TermsService'
    
    export default {
        mixins: [ nameByConstMixin ],
        name: 'index',
        data() {
            return {
                // dialogTermsServiceVisible: false,
                // dialogTermsPrivacyVisible: false,
            }
        },
        created(){
            AOS.init()
        },
        //components: { TermsPrivacy, TermsService }
    }
</script>

<style scoped src="@/assets/css/new/main.css"></style>
<style scoped src="@/assets/css/new/common.css"></style>